import React, { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../../theme/variables';
import Lottie from '../common/Lottie';
import DrawingsMidpoint from '../../assets/lotties/DrawingsMidpoint.json';
import DrawingsCorners from '../../assets/lotties/DrawingsCorners.json';
import DrawingsCenter from '../../assets/lotties/DrawingsCenter.json';
// import DrawingsMidpointPortrait from '../../assets/lotties/Drawingss
import CheckButton from '../common/CheckButton';
import { ReactComponent as GridGraphic } from '../../assets/icons/GridGraphic.svg';
import { ReactComponent as DrawingsCornersPortrait } from '../../assets/icons/ToolsCorners.svg';
import { ReactComponent as DrawingsMidpointPortrait } from '../../assets/icons/ToolsMidpoint.svg';
import { ReactComponent as DrawingsCenterPortrait } from '../../assets/icons/ToolsCenter.svg';

const useStyles = createUseStyles(
    {
        wrap: {
            position: 'relative',
            height: `var(--app-height)`,
            width: '100%',
            overflow: 'hidden',
        },

        graphicsContainer: {
            height: 2048,
            width: 2880,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transformOrigin: 'center center',
        },

        footer: {
            position: 'absolute',
            bottom: 50,
            left: '50%',
            transform: 'translate(-50%)',
        },

        controls: {
            display: 'flex',
            justifyContent: 'center',
        },

        animation: {
            position: 'absolute',
            top: 0,
            left: 0,

            '@media (max-width: 1023px)': {
                display: 'none',
            },

            // '@media (orientation: portrait)': {
            //     display: 'none',
            // },
        },

        // animationPortrait: {
        //     position: 'absolute',
        //     top: 0,
        //     left: 0,

        //     '@media (orientation: landscape)': {
        //         display: 'none',
        //     },
        // },

        footerQuote: {
            marginTop: 24,
            textAlign: 'center',
            fontSize: 16,
            lineHeight: '23px',

            '@media (min-width: 1024px)': {
                marginTop: 45,
                fontSize: 18,
                lineHeight: '28px',
            },
        },

        quoteAuthor: {
            fontSize: 12,
            color: variables.palette.grey[500],
            marginTop: 5,

            '@media (min-width: 1024px)': {
                fontSize: 14,
            },
        },

        svgWrap: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            height: '100vh',
            width: '300vh',
            transform: 'translate(-50%, -50%)',

            '@media (min-width: 1024px)': {
                display: 'none',
            },
        },

        svg: {
            position: 'absolute',
            height: '100vh',
            width: 'auto',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            transition: 'opacity 0.6s ease-in-out',

            '@media (min-aspect-ratio: 900/1440)': {
                height: 'auto',
                width: '100vw',
            },
        },
    },
    { name: 'ToolsInteractive' }
);

const lottieHeight = 2048;
const lottieWidth = 2880;
const lottieRatio = lottieWidth / lottieHeight;

const lottiePortraitHeight = 1920;
const lottiePortraitWidth = 1080;
const lottiePortraitRatio = lottiePortraitWidth / lottiePortraitHeight;

export default function Tools() {
    const classes = useStyles();

    const wrapRef = useRef();
    const containerRef = useRef();

    const [scale, setScale] = useState();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [animationsState, setAnimationsState] = useState({
        corners: 'out', // in | out,
        center: 'out', // in | out,
        midpoint: 'out', // in | out,
    });

    const toggleAnimation = (animationKey, checked) => {
        setAnimationsState((val) => {
            const newState = { ...val };

            if (checked) {
                newState[animationKey] = 'in';
            } else {
                newState[animationKey] = 'out';
            }

            return newState;
        });
    };

    useEffect(() => {
        function recalcScale() {
            if (wrapRef.current) {
                const w = wrapRef.current.offsetWidth;
                const h = wrapRef.current.offsetHeight;

                if (w < h) {
                    // IF PORTRAIT
                    if (w / h < lottiePortraitRatio) {
                        setScale(h / lottiePortraitHeight);
                    } else {
                        setScale(w / lottiePortraitWidth);
                    }
                } else {
                    // IF LANDSCAPE
                    if (w / h < lottieRatio) {
                        setScale(h / lottieHeight);
                    } else {
                        setScale(w / lottieWidth);
                    }
                }
            }

            setWindowWidth(window.innerWidth);
        }

        window.addEventListener('resize', recalcScale);
        recalcScale();

        return () => {
            window.removeEventListener('resize', recalcScale);
        };
    }, [wrapRef.current]);

    return (
        <div className={classes.wrap} ref={wrapRef}>
            <div className={classes.svgWrap}>
                <DrawingsCornersPortrait
                    className={classes.svg}
                    style={{
                        opacity: animationsState.corners === 'in' ? 1 : 0,
                    }}
                />
                <DrawingsMidpointPortrait
                    className={classes.svg}
                    style={{
                        opacity: animationsState.midpoint === 'in' ? 1 : 0,
                    }}
                />
                <DrawingsCenterPortrait
                    className={classes.svg}
                    style={{
                        opacity: animationsState.center === 'in' ? 1 : 0,
                    }}
                />
            </div>

            <div
                className={classes.graphicsContainer}
                ref={containerRef}
                style={{
                    transform: `translate(-50%, -50%) scale(${scale})`,
                }}
            >
                <GridGraphic width="100%" height="100%" />
                {windowWidth >= 1024 && (
                    <>
                        <Lottie
                            className={classes.animation}
                            width={'100%'}
                            height={'100%'}
                            animationData={DrawingsMidpoint}
                            loop={false}
                            autoplay={true}
                            direction={
                                animationsState.midpoint === 'in' ? 1 : -1
                            }
                        />

                        <Lottie
                            className={classes.animation}
                            width={'100%'}
                            height={'100%'}
                            animationData={DrawingsCenter}
                            loop={false}
                            autoplay={true}
                            direction={animationsState.center === 'in' ? 1 : -1}
                        />

                        <Lottie
                            className={classes.animation}
                            width={'100%'}
                            height={'100%'}
                            animationData={DrawingsCorners}
                            loop={false}
                            autoplay={true}
                            direction={
                                animationsState.corners === 'in' ? 1 : -1
                            }
                        />
                    </>
                )}

                {/* <Lottie
                    className={classes.animationPortrait}
                    width={'100%'}
                    height={'100%'}
                    animationData={DrawingsMidpointPortrait}
                    loop={false}
                    autoplay={true}
                    direction={animationsState.midpoint === 'in' ? 1 : -1}
                />

                <Lottie
                    className={classes.animationPortrait}
                    width={'100%'}
                    height={'100%'}
                    animationData={DrawingsCenterPortrait}
                    loop={false}
                    autoplay={true}
                    direction={animationsState.center === 'in' ? 1 : -1}
                />

                <Lottie
                    className={classes.animationPortrait}
                    width={'100%'}
                    height={'100%'}
                    animationData={DrawingsCornersPortrait}
                    loop={false}
                    autoplay={true}
                    direction={animationsState.corners === 'in' ? 1 : -1}
                /> */}
            </div>

            <div className={classes.footer}>
                <div className={classes.controls}>
                    <CheckButton
                        onChange={(checked) =>
                            toggleAnimation('corners', checked)
                        }
                        id="corners"
                        text="Corners"
                    />

                    <CheckButton
                        onChange={(checked) =>
                            toggleAnimation('center', checked)
                        }
                        id="center"
                        text="Center"
                    />

                    <CheckButton
                        onChange={(checked) =>
                            toggleAnimation('midpoint', checked)
                        }
                        id="midpoint"
                        text="Midpoint"
                    />
                </div>
                <figure className={classes.footerQuote}>
                    <p>
                        Recreate Sol’s famous <em>Wall Drawing #273</em>
                    </p>
                </figure>
            </div>
        </div>
    );
}
